export const StoreLandingPageInitialState = {
  page: null,
  loading: false,
  error: null,
};
